function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { StylesProvider, ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import defaultTheme from './themes/default';
var theme = defaultTheme();

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      generateClassName = _ref.generateClassName,
      other = _objectWithoutProperties(_ref, ["children", "generateClassName"]);

  return React.createElement(StylesProvider, {
    generateClassName: generateClassName
  }, React.createElement(MuiThemeProvider, _extends({
    theme: theme
  }, other), children));
};

ThemeProvider.propTypes = {
  /**
   * The child components to which the theme will be applied.
   */
  children: PropTypes.node.isRequired,

  /**
   * Allows sharing of class name generator so that generated class names
   * will remain unique even when rendering multiple react trees.
   */
  generateClassName: PropTypes.any
};
export default ThemeProvider;